import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { tokens } from "../../../theme";

import { useGridApiRef } from "@mui/x-data-grid";

// import SPOrderDetails from "../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails";
import { useTranslation } from 'react-i18next';

import TabView3 from "../../../components/theme/TabView3/TabView3";
import { relationReturnsConfig } from "./relationReturnsConfig";
import ReturnsCompleted from "./views/Completed";
import ReturnsExpected from "./views/Expected";
import ReturnsProcessed from "./views/Processed";
import Returnlines from "./views/Returnlines";

import { useTopbar } from "../../../contexts/TopbarProvider";
import PaidReturnsWithoutShipments from "./views/PaidReturnsWithoutShipments";
import { UserPrivileges } from "../../../utils/permissions";
import { selectUserPermission } from "../../../newapi/user/authentication/authSlice";
import { useSelector } from "react-redux";
import ReturnTotalsPanel from "../../../components/global/dashboard/ReturnTotalsPanel";

const RelationReturns = () => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    
    const [isExtended, setIsExtended] = useState(false);

    const returnsRef = useGridApiRef();

    const [data, setData] = useState({});

    const hasReturnManagePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_RETURN_MANAGE])
    );

    const [config,setConfig] = useState(relationReturnsConfig(hasReturnManagePermission));
    useEffect(() => {
        setConfig(relationReturnsConfig(hasReturnManagePermission));
    },[hasReturnManagePermission])

    const { showExtraTitle,clearExtraTitle } = useTopbar();

    useEffect(() => {
        showExtraTitle(t("returns"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    return (
        <Box sx={{background:"", width:1,paddingTop:9}}>
            {ready ?
            <>
                <ReturnTotalsPanel byState />

                <TabView3
                    tabConfig={config}
                    sx={{
                        background:"green",
                        minHeight:"calc(100% - 431px)",
                        background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        position:"relative",
                        zIndex:2,
                        display:"flex",
                        flexDirection:"column",

                        "&:before" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            left:0,
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            top:"40px",
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transition:"250ms"
                        },

                        "&:after" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            top:"40px",
                            right:0,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transform:"scaleX(-1)",
                            transition:"250ms"
                        },

                        "@media screen and (max-width: 47.9375em)" : {
                            "&:after, &:before" : {
                                top:"-0px"
                            }
                        }
                    }}
                >
                    <>
                        <ReturnsProcessed config={config.processedReturns} />
                        <ReturnsExpected config={config.expectedReturns} />
                        <ReturnsCompleted config={config.completedReturns} />
                        <Returnlines config={config.returnlines} />
                        {hasReturnManagePermission &&
                            <PaidReturnsWithoutShipments config={relationReturnsConfig.paid_returns_no_shipments} />
                        }
                    </>
                </TabView3>
            </>
            :null}
        </Box>
    );
};

export default RelationReturns;